import { FC, Fragment } from 'react';
import { Link, type LinkProps } from '@tanstack/react-router';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

export interface NavBreadcrumbItem {
  text: string;
  path: LinkProps['to'];
  params?: LinkProps['params'];
}

interface NavBreadcrumbProps {
  crumbs: Array<NavBreadcrumbItem>;
}

export const NavBreadcrumb: FC<NavBreadcrumbProps> = ({
  crumbs,
}: NavBreadcrumbProps) => (
  <Breadcrumb>
    <BreadcrumbList>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          <Fragment key={`${crumb.path}-${index}`}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {isLast ? (
                <BreadcrumbPage>{crumb.text}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link
                    to={crumb.path}
                    params={crumb.params}>
                    {crumb.text}
                  </Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </Fragment>
        );
      })}
    </BreadcrumbList>
  </Breadcrumb>
);
